module.exports = __webpack_public_path__ + "img/trunk_10x4.47aad0c3.svg";